import { render, staticRenderFns } from "./interface.vue?vue&type=template&id=2d68ff3d&scoped=true&lang=pug&"
import script from "./interface.vue?vue&type=script&lang=js&"
export * from "./interface.vue?vue&type=script&lang=js&"
import style0 from "./interface.vue?vue&type=style&index=0&id=2d68ff3d&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d68ff3d",
  null
  
)

component.options.__file = "interface.vue"
export default component.exports